import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import s from './Home.css';

class Home extends React.Component {
  static propTypes = {
    publications: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  getImageURL(uid) {
    return uid.indexOf('https') !== -1
      ? uid
      : `https://dxfpracgmlczp.cloudfront.net/${uid}`;
  }

  renderGalleryItem(item) {
    const { mast_head_uid, id, url } = item;
    const imgUrl = this.getImageURL(mast_head_uid);
    return (
      <a
        className={s.publicationContainer}
        key={`publication-item-${id}`}
        href={`${url}`}
      >
        {' '}
        <div
          className={s.publicationImg}
          style={{
            backgroundImage: `url("${imgUrl}")`,
          }}
        />
      </a>
    );
  }

  render() {
    return (
      <div className={s.container}>
        <div className={s.intro}>
          <p>
            Trade Link Media Pte Ltd reaches out to various segments of the
            trade professionals within the building and construction industry
            across Asia-Pacific region.
          </p>
          <p>Select a magazine</p>
        </div>
        {this.props.publications.map(item => this.renderGalleryItem(item))}
        <div>
          <a href="/subscribe" className={s.subscribeBtn}>
            Subscribe Today&nbsp;
            <i className="fa fa-arrow-circle-right" />
          </a>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Home);
